var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-arrow-left ")]),_vm._v(" Back to checklist ")],1)],1),_c(_vm.component,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }